var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"media-button",attrs:{"tabindex":"0"}},[_c('div',{staticClass:"media-button-preview",attrs:{"aria-hidden":"true"}},[_vm._t("preview")],2),_c('div',{staticClass:"media-button-overlay",attrs:{"tabindex":"-1"}},[_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }